/* eslint-disable no-undef, class-methods-use-this, prefer-destructuring, no-param-reassign */

class Gallery {
  constructor() {
    const gallery = document.getElementsByClassName("gallery")[0];
    if (gallery) {
      this.init();
    }
  }

  init() {
    import(/* webpackChunkName: "fslightbox" */ "fslightbox").then(() => {
      refreshFsLightbox();
    });

    document.querySelectorAll(".gallery__thumbnails").forEach((item) => {
      const divLength = item.getElementsByTagName("div").length;
      if (divLength === 2) {
        item.classList.add("gallery__thumbnails__2-col");
      } else if (divLength > 2) {
        item.classList.add("gallery__thumbnails__3-col");
      }
    });
  }
}

export default Gallery;
